export const marketingZhCN = {
  // FreeMagnetPage
  'marketing.free.seo.title': '免费快速入门',
  'marketing.free.seo.description':
    '获取免费的 Grymwyrd 快速入门——规则与可以今晚进行的单人冒险。进入暮光之地。',
  'marketing.free.eyebrow': '你的自由通行证',
  'marketing.free.heading': '进入暮光之地——免费',
  'marketing.free.subheadLead': '《',
  'marketing.free.quickstartName': 'Grymwyrd 快速入门',
  'marketing.free.subheadTail':
    '》——核心规则加上一个可以今晚运行的单幕冒险。告诉我们发送地址。',
  'marketing.free.benefit.rules.title': '规则书',
  'marketing.free.benefit.rules.body': '所需的一切，凝聚在快速入门中。',
  'marketing.free.benefit.oneShot.title': '单幕冒险',
  'marketing.free.benefit.oneShot.body': '为首场夜晚准备的恐怖冒险。',
  'marketing.free.benefit.livingWorld.title': '活跃的世界',
  'marketing.free.benefit.livingWorld.body': '与百科全书、地图和周更内容的交互。',
  'marketing.free.playInstead.heading': '想直接游玩？',
  'marketing.free.playInstead.body':
    '塑造你的第一个角色并进行 10 分钟的单人试玩——无需购买，无需承诺。',
  'marketing.free.playInstead.cta': '创建角色',

  // LeadCaptureForm
  'marketing.leadForm.error.generic': '出问题了。请稍后重试。',
  'marketing.leadForm.ready': '你的免费快速入门已准备好。',
  'marketing.leadForm.downloadCta': '下载你的快速入门',
  'marketing.leadForm.alsoEmailed': '我们也已将链接发送到你的邮箱。',
  'marketing.leadForm.checkInbox': '检查你的收件箱——你的免费快速入门即将到达。',
  'marketing.leadForm.emailPlaceholder': 'you@example.com',
  'marketing.leadForm.emailAriaLabel': '电子邮件地址',
  'marketing.leadForm.defaultCta': '发送快速入门给我',
  'marketing.leadForm.privacyNote':
    '无垃圾邮件——仅快速入门和偶尔的背景故事。随时取消订阅。',
}
